var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaffle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v.001-.002c-3.892 6.754-8.395 13.077-13.474 18.845-18.634 22.058-44.125 34.053-70.467 33.16l-61.816-2.097c-14.416-.489-22.468-19.904-13.977-33.705l8.973-14.586c8.173 6.791 20.499 2.995 27.689-8.605 7.229-11.662 6.544-26.818-1.501-33.964l15.138-24.606c8.171 7.027 20.643 3.265 27.894-8.433 7.268-11.726 6.537-26.984-1.634-34.08l-.07-.06 15.139-24.606.142.126c8.171 7.096 20.686 3.343 27.954-8.382 7.267-11.726 6.536-26.985-1.634-34.081l-.274-.232 35.836-58.252c1.644-2.671 4.23-3.882 6.728-3.63L16.738-81.55C19.731-52.591 13.624-23.649 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(268.291 244.722)",
    fill: "#FECC83",
    "data-original": "#fecc83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-61.815 2.097c-26.343.893-51.833-11.102-70.468-33.16-5.079-5.768-9.582-12.09-13.473-18.843v-.001c13.624-23.65 19.732-52.591 16.738-81.55l-16.091-155.64c2.067.209 4.074 1.419 5.434 3.631l35.836 58.252c-.092.076-.182.153-.274.232-8.17 7.096-8.902 22.355-1.633 34.081 7.267 11.725 19.783 15.478 27.953 8.381l.143-.126 15.137 24.607-.069.06c-8.17 7.096-8.901 22.354-1.634 34.08 7.251 11.698 19.723 15.46 27.895 8.433l15.137 24.606c-8.045 7.146-8.729 22.301-1.501 33.964 7.19 11.6 19.516 15.396 27.69 8.605l8.973 14.586C22.468-19.904 14.416-.489 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(414.047 294.629)",
    fill: "#FCBF66",
    "data-original": "#fcbf66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.984-1.634-34.08-8.17-7.097-20.685-3.344-27.953 8.382-7.268 11.725-6.537 26.984 1.633 34.08C-19.783 15.479-7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(145.22 237.732)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.983-1.634-34.08-8.17-7.097-20.685-3.344-27.953 8.382-7.268 11.725-6.537 26.984 1.633 34.081C-19.783 15.479-7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(186.75 170.73)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.984-1.633-34.08-8.171-7.097-20.686-3.344-27.954 8.382-7.268 11.725-6.537 26.983 1.634 34.08C-19.783 15.479-7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(210.95 243.287)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.983-1.633-34.08-8.171-7.097-20.686-3.344-27.954 8.382-7.268 11.725-6.537 26.984 1.634 34.081C-19.783 15.479-7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(252.481 176.284)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.984-1.634-34.081-8.17-7.096-20.685-3.343-27.953 8.383-7.268 11.725-6.537 26.983 1.633 34.08C-19.783 15.479-7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(228.28 103.728)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.269-11.726-6.537-26.984 1.633-34.08 8.171-7.097 20.685-3.344 27.954 8.382 7.267 11.725 6.536 26.984-1.634 34.08C19.783 15.479 7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(391.362 237.732)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.268-11.726-6.536-26.983 1.634-34.08 8.17-7.097 20.685-3.344 27.953 8.382 7.268 11.725 6.537 26.984-1.634 34.081C19.783 15.479 7.269 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(349.831 170.73)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.268-11.726-6.536-26.983 1.634-34.08 8.17-7.097 20.685-3.344 27.953 8.382 7.268 11.725 6.537 26.984-1.634 34.081C19.783 15.479 7.269 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(326.282 242.72)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.269-11.726-6.537-26.984 1.633-34.081 8.171-7.096 20.685-3.343 27.954 8.383 7.267 11.725 6.536 26.983-1.634 34.08C19.783 15.479 7.268 11.726 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(308.3 103.728)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.799 6.774-19.557 3.662-26.932-6.834a140.167 140.167 0 0 0-.744-14.095l-1.84-17.792a17.032 17.032 0 0 1 3.196-3.742c8.171-7.096 20.685-3.343 27.954 8.383C8.901-22.354 8.17-7.097 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(312.705 184.1)",
    fill: "#FED9A4",
    "data-original": "#fed9a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.106.076C-9.015 6.393-12.89 17.393-10.404 27.652c4.151 17.14 1.822 35.215-5.416 51.297-21.07 46.811-64.441 79.742-115.191 87.463l-44.973 6.842c-6.259.952-10.92-5.647-7.93-11.227l21.515-40.155a30.616 30.616 0 0 0-5.338-36.108l-27.089-27.088c-8.23-8.231-12.586-19.421-12.714-31.06-.121-10.995-5.643-21.177-14.668-27.487-11.807-8.255-20.055-21.248-21.986-36.221l49.057 1.664c26.343.894 51.833-11.101 70.468-33.16 5.079-5.767 9.582-12.091 13.474-18.845 3.89 6.754 8.393 13.078 13.472 18.845 18.635 22.059 44.125 34.054 70.468 33.16l49.058-1.664C19.881-21.197 11.708-8.261 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(379.486 331.153)",
    fill: "#FFF1E2",
    "data-original": "#fff1e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.106.076C-9.015 6.393-12.89 17.393-10.404 27.652c4.151 17.14 1.822 35.215-5.416 51.297-21.07 46.811-64.441 79.742-115.191 87.463l-44.973 6.842c-6.259.952-10.92-5.647-7.93-11.227l21.515-40.155a30.616 30.616 0 0 0-5.338-36.108l-27.089-27.088c-8.23-8.231-12.586-19.421-12.714-31.06-.121-10.995-5.643-21.177-14.668-27.487-11.807-8.255-20.055-21.248-21.986-36.221l49.057 1.664c26.343.894 51.833-11.101 70.468-33.16 5.079-5.767 9.582-12.091 13.474-18.845 3.89 6.754 8.393 13.078 13.472 18.845 18.635 22.059 44.125 34.054 70.468 33.16l49.058-1.664C19.881-21.197 11.708-8.261 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(379.486 331.153)",
    fill: "#FFF1E2",
    "data-original": "#fff1e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.106.076C-9.015 6.393-12.89 17.393-10.404 27.652c4.151 17.14 1.822 35.216-5.416 51.297-17.637 39.186-50.903 68.646-91.042 81.733A151.211 151.211 0 0 0-55.82 98.949c7.238-16.081 9.567-34.157 5.416-51.297-2.486-10.259 1.389-21.259 10.298-27.576L-40 20l.342-.243c15.584-11.189 7.482-35.849-11.702-35.849h-169.905c-11.484 0-21.384-8.399-22.901-19.783l-.028-.217 49.057 1.664c26.343.894 51.833-11.1 70.468-33.16 5.079-5.767 9.582-12.091 13.474-18.845 3.89 6.754 8.393 13.078 13.472 18.845 18.635 22.06 44.125 34.054 70.468 33.16l49.058-1.664C19.881-21.197 11.708-8.261 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(379.486 331.153)",
    fill: "#FFEDD0",
    "data-original": "#ffedd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 11.472-9.3 20.771-20.771 20.771-11.472 0-20.771-9.299-20.771-20.771 0-11.472 9.299-20.771 20.771-20.771C-9.3-20.771 0-11.472 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(343.865 346.929)",
    fill: "#91DEB3",
    "data-original": "#91deb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a26.114 26.114 0 0 1 10.397-15.624l.107-.076.342-.243a20.535 20.535 0 0 0 4.036-3.795C14.799-10.394 8.547-2.522 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(328.982 366.853)",
    fill: "#6DD4A1",
    "data-original": "#6dd4a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.169 4.011 10.249 10.965 10.249 18.871 0 12.424-10.071 22.495-22.495 22.495-12.423 0-22.494-10.071-22.494-22.495 0-3.478.789-6.772 2.199-9.713C-21.254 8.384-10.246 5.256 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(225.177 287.424)",
    fill: "#FC636F",
    "data-original": "#fc636f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-3.479.79-6.772 2.2-9.713 11.286-.773 22.295-3.902 32.54-9.158C40.909-14.86 44.989-7.906 44.989 0c0 3.11-.631 6.072-1.772 8.767H1.772A22.431 22.431 0 0 1 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(190.436 306.295)",
    fill: "#FB4954",
    "data-original": "#fb4954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c8.088 5.655 13.361 14.419 14.457 24.091l-63.044 109.196c-4.17 7.223-13.405 9.696-20.627 5.527-7.223-4.169-9.697-13.405-5.527-20.626L-4.48-3.509A52.451 52.451 0 0 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(157.278 331.282)",
    fill: "#B98181",
    "data-original": "#b98181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a52.767 52.767 0 0 1-5.5-4.423L5.52-23.509A52.451 52.451 0 0 0 10-20c8.088 5.655 13.361 14.419 14.457 24.091l-10.312 17.86C12.563 13.134 7.487 5.235 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(147.278 351.282)",
    fill: "#AE6B6B",
    "data-original": "#ae6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.984-1.634-34.08-8.17-7.097-20.685-3.344-27.953 8.382-7.268 11.725-6.537 26.984 1.633 34.08C-19.783 15.479-7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(145.22 237.732)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.983-1.634-34.08-8.17-7.097-20.685-3.344-27.953 8.382-7.268 11.725-6.537 26.984 1.633 34.081C-19.783 15.479-7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(186.75 170.73)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.984-1.633-34.08-8.171-7.097-20.686-3.344-27.954 8.382-7.268 11.725-6.537 26.983 1.634 34.08C-19.783 15.479-7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(210.95 243.287)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.983-1.633-34.08-8.171-7.097-20.686-3.344-27.954 8.382-7.268 11.725-6.537 26.984 1.634 34.081C-19.783 15.479-7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(252.481 176.284)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.268-11.726 6.537-26.984-1.634-34.081-8.17-7.096-20.685-3.343-27.953 8.383-7.268 11.725-6.537 26.983 1.633 34.08C-19.783 15.479-7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(228.28 103.728)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.269-11.726-6.537-26.984 1.633-34.08 8.171-7.097 20.685-3.344 27.954 8.382 7.267 11.725 6.536 26.984-1.634 34.08C19.783 15.479 7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(391.362 237.732)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.268-11.726-6.536-26.983 1.634-34.08 8.17-7.097 20.685-3.344 27.953 8.382 7.268 11.725 6.537 26.984-1.634 34.081C19.783 15.479 7.269 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(349.831 170.73)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.268-11.726-6.536-26.983 1.634-34.08 8.17-7.097 20.685-3.344 27.953 8.382 7.268 11.725 6.537 26.984-1.634 34.081C19.783 15.479 7.269 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(326.282 242.72)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.269-11.726-6.537-26.984 1.633-34.081 8.171-7.096 20.685-3.343 27.954 8.383 7.267 11.725 6.536 26.983-1.634 34.08C19.783 15.479 7.268 11.726 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(308.3 103.728)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.677 45.227c2.993 28.959-3.115 57.9-16.739 81.549v.001-.002c-3.891 6.754-8.394 13.078-13.473 18.845-18.635 22.059-44.125 34.054-70.468 33.16l-61.815-2.096c-14.416-.49-22.468-19.905-13.978-33.705l8.973-14.586",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(280.353 117.945)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a27.998 27.998 0 0 0-.274-.231l35.836-58.252c1.644-2.672 4.23-3.883 6.729-3.631l7.75 74.96",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(226.647 69.647)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.07-.06 15.138-24.606.143.126",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(185.116 136.65)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 15.138-24.605",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(143.718 203.769)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.799 6.774-19.557 3.662-26.932-6.834a140.167 140.167 0 0 0-.744-14.095l-1.84-17.792a17.032 17.032 0 0 1 3.196-3.742c8.171-7.096 20.685-3.343 27.954 8.383C8.901-22.354 8.17-7.097 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(312.705 184.1)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.973 14.586c8.49 13.801.438 33.216-13.978 33.705l-61.815 2.097c-26.343.893-51.833-11.102-70.468-33.16-5.079-5.768-9.582-12.09-13.473-18.843v-.001",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(419.052 246.338)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 15.138 24.605",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(377.726 179.163)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .143-.126L15.28 24.48l-.069.06",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(336.254 112.11)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.067.209 4.074 1.419 5.435 3.631l35.836 58.252-.275.231",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(268.938 7.532)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a151.257 151.257 0 0 1-89.429 48.065l-44.973 6.842c-6.259.952-10.92-5.646-7.93-11.226l21.515-40.156a30.616 30.616 0 0 0-5.338-36.108l-27.089-27.088c-8.23-8.23-12.586-19.421-12.714-31.059-.121-10.996-5.643-21.177-14.668-27.488-11.807-8.255-20.055-21.248-21.986-36.22",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(337.904 449.5)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.922 14.895-10.095 27.831-21.803 36.092l-.106.076c-8.908 6.316-12.783 17.316-10.298 27.576 4.151 17.14 1.822 35.215-5.416 51.297a151.545 151.545 0 0 1-5.356 10.742",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(401.29 295.062)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a191.05 191.05 0 0 1 73.601.503",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(246.34 400.416)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.639 4.995",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(285.774 434.978)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13.645 13.645",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(263.14 336.498)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13.644 13.645",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(249.279 447.861)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19.296",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(269.962 306.462)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.638-4.994",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(216.787 365.113)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 11.472-9.3 20.771-20.771 20.771-11.472 0-20.771-9.299-20.771-20.771 0-11.472 9.299-20.771 20.771-20.771C-9.3-20.771 0-11.472 0 0Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(343.865 346.929)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.169 4.011 10.249 10.965 10.249 18.871 0 12.424-10.071 22.495-22.495 22.495-12.423 0-22.494-10.071-22.494-22.495 0-3.478.789-6.772 2.199-9.713",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(225.177 287.424)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.675-32.346",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(134.123 360.12)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-63.044 109.196c-4.17 7.223-13.405 9.697-20.627 5.528-7.223-4.17-9.697-13.406-5.527-20.627l33.87-58.667",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(171.735 355.373)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaffle);
export default __webpack_public_path__ + "static/media/Waffle.1e342625eedafc501b0d3b0977841238.svg";
export { ForwardRef as ReactComponent };